import { Role } from '../Constants/Role.ts'

export default function hasRole(expectedRoles: string | string[] | Role | Role[]): boolean {
  if (!Array.isArray(expectedRoles)) {
    expectedRoles = [expectedRoles]
  }

  return expectedRoles.some((role: string | Role) => roles.includes(role))
}
